const sortAlphaNum = (a, b) => a.localeCompare(b, 'en', { numeric: true });
export default sortAlphaNum;
